import { Button } from '@sorrem-client/ui/components';
import { AccessScreen } from '@sorrem-client/ui/features/LoginPage';

/** Which role-gated set of pages turned the account away. */
export type GatedPageSet = 'developer' | 'editor';

const DENIED_COPY: Record<GatedPageSet, { readonly ariaLabel: string; readonly title: string; readonly subtitle: string }> = {
    developer: {
        ariaLabel: 'Developer access denied panel',
        title: 'Developer Access Required',
        subtitle: 'This account does not currently have the Discord role required to view debug tools.',
    },
    editor: {
        ariaLabel: 'Creator access denied panel',
        title: 'Creator Access Required',
        subtitle: 'This account does not currently have the Discord creator role required to use the editors.',
    },
};

interface DeveloperAccessDeniedPageProps {
    pageSet: GatedPageSet;
    onReturn: () => void;
}

/**
 * Shown on a developer route (/debug/*, /lore) when the signed-in account lacks the Discord developer role,
 * or on an editor route (/editors/*) when it lacks the creator role (and is not a developer).
 */
export function DeveloperAccessDeniedPage({ pageSet, onReturn }: DeveloperAccessDeniedPageProps): JSX.Element {
    const copy = DENIED_COPY[pageSet];

    return (
        <AccessScreen
            ariaLabel={copy.ariaLabel}
            kicker="Sorrem Access"
            title={copy.title}
            subtitle={copy.subtitle}
        >
            <Button type="button" variant="secondary" onClick={onReturn}>
                Return to character
            </Button>
        </AccessScreen>
    );
}
